import { translate } from '@teamleader/i18n';
import cx from 'classnames';
import React, { useCallback, useContext } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';

import DueDateLabel from './DueDateLabel';
import useCurrencyFormatter from '../../../../Components/Context/Hooks/useCurrencyFormatter';
import Box from '../../../../Components/UI/Box';
import { ListInvoice, MATCHED_STATUS } from '../../../../Types/invoice';
import { EVENTS, track } from '../../../../Utils/analytics';
import { InvoiceContext } from '../../Context';
import * as styles from '../styles.css';

interface InvoiceProps {
  invoice: ListInvoice;
  onClick?: (quotation: ListInvoice) => void;
}

const Invoice: React.FC<InvoiceProps> = ({ invoice, onClick }) => {
  const { invoiceId, department } = useContext(InvoiceContext);
  const { token } = useParams<HomeRouteProps>();
  const formatter = useCurrencyFormatter(invoice?.total.due.currency);

  const handleClick = useCallback(() => {
    track(EVENTS.SELECTED_INVOICE, { invoice: invoice.id });

    if (onClick) {
      onClick(invoice);
    }
  }, [invoice, onClick]);

  const isSelected = invoice.id === invoiceId;

  return (
    <Box
      element={Link}
      to={`/${token || ''}/${invoice.id}`}
      onClick={handleClick}
      className={cx(styles['sub-item'], { [styles['selected']]: isSelected })}
      display="flex"
      alignItems="center"
      justifyContent="space-between"
    >
      <Box display="flex" flexDirection="column">
        <h4 className={styles['title']}>{translate('title.invoice', { invoiceNumber: invoice.invoiceNumber })}</h4>
        {invoice.matchedStatus === MATCHED_STATUS.UNMATCHED && (
          <span className={styles['amount']}>{formatter.format(invoice.total.due.amount)}</span>
        )}
        {(invoice.matchedStatus === MATCHED_STATUS.FULLY_PAID ||
          invoice.matchedStatus === MATCHED_STATUS.MIXED ||
          invoice.matchedStatus === MATCHED_STATUS.FULLY_CREDITED) && (
          <span className={styles['amount']}>{formatter.format(invoice.total.payable.amount)}</span>
        )}
      </Box>
      {department && invoice.matchedStatus === MATCHED_STATUS.UNMATCHED && (
        <DueDateLabel dueDate={invoice.dueDate} dateFormat={department.dateFormat} marginLeft={2} />
      )}
    </Box>
  );
};

export default Invoice;
